import PropTypes from 'prop-types';
import React from 'react';

import Formsy from 'formsy-react';

import Alert from './ui/Alert';
import Anime from './ui/Anime';
import Box from './ui/Box';
import Button from './ui/Button';
import AuthForm from './ui/Form';
import FormGroup from './ui/FormGroup';
import Header from './ui/Header';
import Input from './ui/Input';
import Label from './ui/Label';
import Link from './ui/Link';
import LoadingIcon from './ui/LoadingIcon';
import Wrapper from './ui/Wrapper';

export default class ForgotForm extends React.Component {
  state = {
    email: null,
    new_password_verification: null,
    new_password: null,
    nomatch_password: false,
  }

  handleChange(property) {
    return event => {
      this.setState({ [property]: event.target.value });
    }
  }

  handleSubmit = model => {
    this.props.handleSubmit(Object.assign(this.state, model));
  }

  handleCheckSubmit = model => {
    if (this.state.new_password === this.state.new_password_verification) {
      this.setState({ nomatch_password: false })
      this.handleSubmit(model);
    } else {
      this.setState({ nomatch_password: true })
    }
  }

  SendEmailForm = () => <Formsy onValidSubmit={this.handleSubmit}>
    <Anime>
      <Box>
        <Wrapper>
          <Header text='Password reset' />
          <AuthForm>
            <FormGroup>
              <Label>
                Email Address
              </Label>
              <Input
                required
                type="email"
                name="email"
                value={this.state.email}
                onChange={this.handleChange('email')}
              />
            </FormGroup>
            <Button type="submit" disabled={this.props.isLoading}>
              Email link
              {this.props.isLoading && <LoadingIcon />}
            </Button>
            <Link to="/auth/login">
              Login
            </Link>
          </AuthForm>
        </Wrapper>
        <Alert color={this.props.feedback?.type} isOpen={this.props.feedback?.text}>
          {this.props.feedback?.text}
        </Alert>
      </Box>
    </Anime>
  </Formsy>

  FeedbackMessage = () => <Anime>
    <Box>
      <Wrapper>
        <Header text='Password Reset' />
        <Alert color="success" isOpen>
          {this.props.feedback.text}
        </Alert>
        <Link to="/auth/login">
          Login
        </Link>
      </Wrapper>
    </Box>
  </Anime>

  NewPasswordForm = () => <Formsy onValidSubmit={this.handleCheckSubmit}>
    <Anime>
      <Box>
        <Wrapper>
          <Header text='Password reset' />
          <AuthForm>
            <FormGroup>
              <Label>
                New password
              </Label>
              <Input
                invalid={this.state.nomatch_password}
                type="password"
                name="new_password"
                required
                onChange={this.handleChange('new_password')}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Confirm the new password
              </Label>
              <Input
                invalid={this.state.nomatch_password}
                type="password"
                name="new_password_verification"
                required onChange={this.handleChange('new_password_verification')}
              />
            </FormGroup>
            <Button disabled={this.props.isLoading} type="submit">
              Reset password
              {this.props.isLoading && <LoadingIcon />}
            </Button>
          </AuthForm>
        </Wrapper>
        <Alert color="danger" isOpen={this.state.nomatch_password}>The passwords does not match</Alert>
      </Box>
    </Anime>
  </Formsy>

  render() {
    if (!this.props.isVerified) {
      return <this.SendEmailForm />
    }

    if (this.props.isValidated) {
      return <this.NewPasswordForm />
    }

    return <this.FeedbackMessage />
  }
}
ForgotForm.propTypes = {
  handleSubmit: PropTypes.func,
  isVerified: PropTypes.boll,
  feedback: PropTypes.any,
  isLoading: PropTypes.bool,
  isValidated: PropTypes.bool,
};
